const sources = [
  {
    name: "Current Date/Time",
    code: "app.date()",
    params: [],
    returnType: "Date",
    returnList: false,
    category: "App Data",
  },
  {
    name: "Current user",
    code: "auth.user",
    params: [],
    returnType: "user",
    returnList: false,
    category: "App Data",
  },
  {
    name: "Current Page Width",
    code: "app.pageWidth()",
    params: [],
    returnType: "Number",
    returnList: false,
    category: "App Data",
  },
  {
    name: "Current Scoll Position",
    code: "app.scrollPosition()",
    params: [],
    returnType: "Number",
    returnList: false,
    category: "App Data",
  },
  {
    name: "is Development Version",
    code: "app.developmentVersion()",
    params: [],
    returnType: "True/False",
    returnList: false,
    category: "App Data",
  },
  {
    name: "Static Number",
    code: "app.staticNumber",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "number",
        editorParams: {},
      },
    ],
    returnType: "Number",
    returnList: false,
    category: "Basic",
  },
];

export default sources;
